<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/supplier">Fornecedores</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Novo fornecedor</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                        <a href="#info" role="tab" data-toggle="tab" class="nav-link active"> Dados gerais </a>
                    </li>
                    <li class="nav-item">
                        <button role="tab" data-toggle="tab" class="nav-link" :disabled="true">
                            Endereço </button>
                    </li>
                    <li class="nav-item">
                        <button role="tab" data-toggle="tab" class="nav-link" :disabled="true">
                            Dados fiscais </button>
                    </li>
                </ul>
                <div class="tab-content">
                    <div class="tab-pane active" role="tabpanel" id="info">
                        <div class="card shadow mb-4">

                            <!-- Card Header - Dropdown -->
                            <div class="card-body">
                                <form @submit="save">
                                    <fieldset>
                                        <legend>Dados Gerais</legend>
                                        <div class="row mt-2">
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">CPF / CNPJ*</label>

                                                <div class="input-group mb-3">
                                                    <input type="text" class="form-control"
                                                        placeholder="Ex: xx.xxx.xxx/xxxx-xx" v-model="supplier.document"
                                                        v-mask="['###.###.###-##', '##.###.###/####-##']"
                                                        @keypress="enableSearchCnpj()">
                                                    <div class="input-group-append">
                                                        <button class="btn btn-success" type="button" id="button-addon2"
                                                            :disabled="searchCnpj" @click="searchCNPJ()"><i
                                                                class="fa fa-search"></i>Buscar
                                                            CNPJ</button>
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="col-xl-8 col-md-8 col-sm-12">
                                                <label for="">Nome / Razão Social*</label>
                                                <input type="text" class="form-control" placeholder="Ex: Empresa XYZ"
                                                    v-model="supplier.name">
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-xl-3 col-md-3 col-sm-12">
                                                <label for="">Telefone</label>
                                                <input type="text" class="form-control"
                                                    placeholder="Ex: (xx)x.xxxx-xxxx" v-model="supplier.phone"
                                                    v-mask="['(##) ####-####', '(##) #####-####']">
                                            </div>
                                            <div class="col-xl-3 col-md-3 col-sm-12">
                                                <label for="">Nome do contato</label>
                                                <input type="text" class="form-control"
                                                    placeholder="Ex: Francisco José Da Silva"
                                                    v-model="supplier.name_contact">
                                            </div>
                                            <div class="col-xl-6 col-md-6 col-sm-12">
                                                <label for="">E-mail</label>
                                                <input type="text" class="form-control"
                                                    placeholder="Ex: usuario@dominio.com" v-model="supplier.email">
                                            </div>
                                        </div>
                                    </fieldset>
                                    <br>
                                    <fieldset>
                                        <legend>Obvervações</legend>
                                        <div class="row mb-4">
                                            <div class="col-lg-12 col-xs-12 col-sm-12">
                                                <label for="">Observações</label>
                                                <editorText @update-text="updateObservation"
                                                    :modelValue="supplier.observation"
                                                    placeholderSend="Sem observações"></editorText>
                                            </div>
                                        </div>
                                        <br> <br>
                                    </fieldset>
                                    <br>
                                    <div class="row">
                                        <div class="col-xl-12 col-md-12 col-sm-12">
                                            <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                                    class="fa fa-save"></i> Cadastrar</button>
                                            <router-link to="/supplier" class="btn btn-danger ml-3"><i
                                                    class="fa fa-times"></i>
                                                Cancelar</router-link>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane" role="tabpanel" id="ratings">
                        <h3> Ratings </h3>
                        <p> Lorem ipsum dolorem </p>
                    </div>
                    <div class="tab-pane" role="tabpanel" id="plus">
                        <h3> + </h3>
                        <p> Sit amet </p>
                    </div>
                </div>


            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { getCNPJ } from '@/api-external';
import { handleRequestErrors } from '@/handleErrors';
import { capitalize, maskPhone } from '@/util';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'
import editorText from '../util/editor-text.vue';

export default {
    directives: { mask },
    components: { Loading, editorText },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            tab_active: true,
            searchCnpj: true,
            supplier: {
                name: '',
                document: ''
            },
            enable_error_list: false,
            errors: []
        }
    },

    computed: {
        isDisabled: function () {
            return this.supplier.document != '' && this.supplier.name != '';
        }
    },
    mounted() {
        this.isLoading = false;
    },
    methods: {
        onCancel() { },
        enableSearchCnpj() {
            this.searchCnpj = true;
            if (this.supplier.document.length > 0) {
                let cnpj = this.supplier.document.replace(/\D/g, '');
                if (cnpj.length == 13) {
                    this.searchCnpj = false;
                }
            }
        },
        searchCNPJ() {
            this.isLoading = true;
            if (this.supplier.document.length > 0) {
                let cnpj = this.supplier.document.replace(/\D/g, '');
                getCNPJ(cnpj).then((response) => {
                    this.supplier.name = capitalize(response.razao_social);
                    this.supplier.phone = response.ddd_telefone_1 ? maskPhone(response.ddd_telefone_1) : '';
                    this.supplier.email = response.email ? response.email : '';
                    this.isLoading = false;
                }).catch(() => {
                    this.isLoading = false;
                });
            }
        },
        updateObservation(observation) {
            this.supplier.observation = observation;
        },
        save(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            api.post('/supplier', this.supplier)
                .then((response) => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Fornecedor cadastrado com sucesso!",
                        type: 'success'
                    });
                    this.supplier = {};
                    this.$router.push({
                        name: 'supplier_address_edit',
                        params: { id: response.data.supplier.id }
                    });
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status, error);
                })

        }
    }
}
</script>

<style lang="scss" scoped></style>